
import "reflect-metadata";
import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import vueDebounce from 'vue-debounce';
import axios from 'axios';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'jquery';
import 'popper.js';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { decorate, injectable } from "inversify";

decorate( injectable(), Vue );
library.add(fas);

global.Vue = Vue;
global.Vue.config.devtools = process.env.APP_DEBUG;
global.Vue.config.productionTip = process.env.APP_DEBUG;
global.VueRouter = VueRouter;
global.Vuex = Vuex;
global.Vue.use( Vuex );
global.Vue.use( VueRouter );
global.Vue.use( BootstrapVue );
global.Vue.use( CKEditor );
global.Vue.use( Viewer );
global.Vue.use( vueDebounce );
global.Vue.component('font-awesome-icon', FontAwesomeIcon);

global.axios = axios;
global.axios.defaults.headers.common = {
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')!.getAttribute('content'),
    'X-Requested-With': 'XMLHttpRequest'
};

require('Core/Providers');
